var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsIn, IsOptional, IsString } from 'class-validator';
import { howDoYouKnowUsValues, sourceValues } from './deal-create.request';
/**
 * Affected endpoints
 * POST /public/ui/deal
 */
export class DealResponse {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DealResponse.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DealResponse.prototype, "name", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DealResponse.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DealResponse.prototype, "description", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DealResponse.prototype, "company", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DealResponse.prototype, "contactPhone", void 0);
__decorate([
    Expose(),
    IsString(),
    IsIn(howDoYouKnowUsValues),
    IsOptional(),
    __metadata("design:type", Object)
], DealResponse.prototype, "howDoYouKnowUs", void 0);
__decorate([
    IsString(),
    IsIn(sourceValues),
    IsOptional(),
    __metadata("design:type", Object)
], DealResponse.prototype, "source", void 0);
__decorate([
    IsArray(),
    IsString(),
    __metadata("design:type", Array)
], DealResponse.prototype, "consultingOptions", void 0);
//# sourceMappingURL=deal.response.js.map